import { Submeter } from '../types'

export const getSubMeters = (): Submeter[] => {
    return [
        {
            meterId: 1509829,
            meterName: 'ATT - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509831,
            meterName: 'Concessions - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509840,
            meterName: 'CH - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509841,
            meterName: 'Elevator - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509842,
            meterName: 'Fire Alarm - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509843,
            meterName: 'Lighting - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509844,
            meterName: 'Mechanical - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509845,
            meterName: 'Retail - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509846,
            meterName: 'Receptacle - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509847,
            meterName: 'Scoreboard - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509848,
            meterName: 'Sports Lighting - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509849,
            meterName: 'Sprint - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509850,
            meterName: 'Tmobile - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509851,
            meterName: 'Verizon - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509852,
            meterName: 'Water Heater - PSGA',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509853,
            meterName: 'Concessions - PSGB',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509854,
            meterName: 'Elevator - PSGB',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509855,
            meterName: 'Fire Alarm - PSGB',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509856,
            meterName: 'Lighting - PSGB',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509857,
            meterName: 'Mechanical - PSGB',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509858,
            meterName: 'Solar - PSGB',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509859,
            meterName: 'Receptacle - PSGB',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509860,
            meterName: 'Scoreboard - PSGB',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509861,
            meterName: 'SH - PSGB',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509862,
            meterName: 'Sports Lighting - PSGB',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509863,
            meterName: 'Telecom - PSGB',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509864,
            meterName: 'Water Heater - PSGB',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
        {
            meterId: 1509865,
            meterName: 'Room 01_58_07',
            facilityName: '4900 Marie P Debartolo Way, Santa Clara, CA',
            facilityAddress: {
                address1: '4900 Marie P Debartolo Way',
                city: 'Santa Clara',
                state: 'CA',
                country: 'United States',
                zip: '95054',
            },
        },
    ]
}
